module.exports = __webpack_public_path__ + "static/media/collage3_768.988468d2.png";